import type { ComponentProps, ReactNode } from 'react';
import './button.css';

export type ButtonVariant = 'primary' | 'secondary';

export interface ButtonProps extends ComponentProps<'button'> {
  variant?: ButtonVariant;
}

export function Button({ variant = 'primary', type = 'button', className, children, ...props }: ButtonProps) {
  const classes = ['btn', `btn--${variant}`, className].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} {...props}>
      {children}
    </button>
  );
}

export interface ButtonGroupProps {
  children: ReactNode;
  className?: string;
}

export function ButtonGroup({ children, className }: ButtonGroupProps) {
  const classes = ['btn-group', className].filter(Boolean).join(' ');
  return <div className={classes}>{children}</div>;
}
